/** Copy del asistente de citas según rubro de clínica privada. */

export type OrgTipoClinica =
  | 'clinica-medica'
  | 'clinica-odontologica'
  | 'clinica-veterinaria'
  | 'clinica-nutricion'
  | 'clinica-psicologia'
  | 'clinica-estetica'
  | 'clinica-optica'
  | 'clinica-fisioterapia';

export type RubroCopy = {
  emoji: string;
  label: string;
  saludo: string;
  motivoPrompt: string;
  motivoPlaceholder: string;
};

const RUBROS: Record<OrgTipoClinica, RubroCopy> = {
  'clinica-medica': {
    emoji: '🩺',
    label: 'Medicina general',
    saludo: 'Le ayudo a agendar su consulta médica.',
    motivoPrompt: '¿Motivo de la consulta? (fiebre, control, dolor…)',
    motivoPlaceholder: 'Ej. control de presión',
  },
  'clinica-odontologica': {
    emoji: '🦷',
    label: 'Odontología',
    saludo: 'Le ayudo a agendar su cita dental.',
    motivoPrompt: '¿Motivo? (limpieza, dolor, ortodoncia…)',
    motivoPlaceholder: 'Ej. limpieza dental',
  },
  'clinica-veterinaria': {
    emoji: '🐾',
    label: 'Veterinaria',
    saludo: 'Le ayudo a agendar la cita de su mascota.',
    motivoPrompt: '¿Motivo y nombre de la mascota?',
    motivoPlaceholder: 'Ej. vacuna — Max',
  },
  'clinica-nutricion': {
    emoji: '🥗',
    label: 'Nutrición',
    saludo: 'Le ayudo a agendar su cita de nutrición.',
    motivoPrompt: '¿Motivo? (primera consulta, seguimiento…)',
    motivoPlaceholder: 'Ej. plan de peso',
  },
  'clinica-psicologia': {
    emoji: '🧠',
    label: 'Psicología',
    saludo: 'Le ayudo a agendar su sesión.',
    motivoPrompt: '¿Motivo? (primera sesión, seguimiento…)',
    motivoPlaceholder: 'Ej. primera sesión',
  },
  'clinica-estetica': {
    emoji: '✨',
    label: 'Estética',
    saludo: 'Le ayudo a agendar su cita de estética.',
    motivoPrompt: '¿Procedimiento o motivo?',
    motivoPlaceholder: 'Ej. limpieza facial',
  },
  'clinica-optica': {
    emoji: '👓',
    label: 'Óptica',
    saludo: 'Le ayudo a agendar su cita en óptica.',
    motivoPrompt: '¿Motivo? (examen de vista, entrega de lentes…)',
    motivoPlaceholder: 'Ej. examen de vista',
  },
  'clinica-fisioterapia': {
    emoji: '🏃',
    label: 'Fisioterapia',
    saludo: 'Le ayudo a agendar su sesión con el fisioterapista.',
    motivoPrompt: '¿Motivo? (evaluación inicial, rehabilitación, control de sesión…)',
    motivoPlaceholder: 'Ej. dolor lumbar · sesión 3/12',
  },
};

export function rubroFromTipo(tipo?: string | null): RubroCopy {
  if (tipo && tipo in RUBROS) return RUBROS[tipo as OrgTipoClinica];
  return RUBROS['clinica-medica'];
}

export function esClinicaPrivada(edicion?: string | null): boolean {
  return edicion === 'solo-clinic' || edicion === 'clinic-network';
}
